import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { View, Text } from '@olxbr/design-system'
import { Button } from '@olxbr/ds-core'
import MailIcon from '../../atoms/MailIcon'
import LabelBox from '../../atoms/LabelBox'
import LoadingBackdrop from '../../molecules/LoadingBackdrop'
import Title from '../../atoms/Title'
import { activateEmailChangeRequest } from '../../../api/emailChangeApiCall'
import Lurker from '../../../util/lurker'

const lurker = new Lurker('email_change_activation')

const Content = styled(View)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const LabelBoxView = styled(View)`
  width: 100%;
  padding: 7px 51px 8px 51px;
  margin-bottom: 32px;
`

const PageTitle = styled(Title)`
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 32px;
  margin-top: 28px;
  padding: 0 16px;
`

const TitleStart = styled(View)`
  margin-bottom: 8px;
`

const Description = styled(Text)`
  text-align: center;
  margin-top: 24px;
  margin-bottom: 32px;
  line-height: 24px;
  font-size: 16px;
`

const DescriptionWrapper = styled(Description)`
  margin-top: 16px;
`

class EmailChangeActivationTemplate extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      status: 'loading',
      showErrorEmail: false,
    }
  }

  componentDidMount() {
    lurker.pageLoadEvt()
    this.confirmChange()
  }

  confirmChange = () => {
    const { token, confirmationToken } = this.props
    activateEmailChangeRequest(token, confirmationToken)
      .then(() => {
        lurker.viewMessageEvt('success')
        this.setState({ status: 'success' })
      })
      .catch((error = {}) => {
        const { response: { status, data } = {} } = error
        if (status === 422) {
          lurker.viewMessageEvt('error', {
            accounts_reason: 'missing_token',
            accounts_status_code: status,
          })
          this.setState({ status: 'missing_token' })
        } else if (status === 409) {
          if (!!data && data.message && data.message === 'EMAIL_IN_USE') {
            lurker.viewMessageEvt('error', {
              accounts_reason: 'EMAIL_IN_USE',
              accounts_status_code: status,
            })
            this.setState({ status: 'error', showErrorEmail: true })
          } else {
            lurker.viewMessageEvt('error', {
              accounts_reason: 'invalid_token',
              accounts_status_code: status,
            })
            this.setState({ status: 'error' })
          }
        } else if (status) {
          lurker.viewMessageEvt('error', {
            accounts_reason: 'unexpected_status_code',
            accounts_status_code: status,
          })
          this.setState({ status: 'error' })
        } else {
          lurker.viewMessageEvt('error', {
            accounts_reason: 'unexpected_error',
            accounts_error_message: (error && error.message) || 'unknown',
          })
          this.setState({ status: 'error' })
        }
      })
  }

  retryChange = () => {
    const { onRetryChange } = this.props
    lurker.clickEvt('retry_change')
    if (onRetryChange && typeof onRetryChange === 'function') {
      onRetryChange()
    }
  }

  renderErrorView = () => {
    const { showErrorEmail } = this.state
    return (
      <Content>
        <TitleStart>
          <PageTitle>Não foi possível ativar seu novo e-mail</PageTitle>
        </TitleStart>
        <Description fontWeight={400}>
          {showErrorEmail
            ? 'O e-mail informado já possui cadastro'
            : 'Para segurança da sua conta, a ativação enviada por e-mail possui validade.'}
        </Description>
        {!showErrorEmail && (
          <DescriptionWrapper fontWeight={400}>Por favor, tente novamente!</DescriptionWrapper>
        )}
        <Button className="w-full" size="medium" onClick={this.retryChange}>
          Tentar novamente
        </Button>
      </Content>
    )
  }

  render() {
    const { newEmail, onSuccess } = this.props
    const { status } = this.state

    if (status === 'loading') {
      return <LoadingBackdrop />
    }

    if (status === 'success') {
      return (
        <Content>
          <MailIcon />
          <TitleStart>
            <PageTitle>Estamos alterando o seu e-mail</PageTitle>
          </TitleStart>
          <Description fontWeight={400}>
            Aguarde a conclusão para usar o novo e-mail na sua conta. Assim que a alteração for
            concluída, será enviado um aviso para:
          </Description>
          <LabelBoxView>
            <LabelBox>{newEmail}</LabelBox>
          </LabelBoxView>
          <Button className="w-full" size="medium" onClick={onSuccess}>
            Entendi
          </Button>
        </Content>
      )
    }

    return this.renderErrorView()
  }
}

EmailChangeActivationTemplate.propTypes = {
  confirmationToken: PropTypes.string.isRequired,
  newEmail: PropTypes.string.isRequired,
  onRetryChange: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
}

export default EmailChangeActivationTemplate
